var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "tab" }, [
    _vm.loading
      ? _c("div", [_vm._v("Loading...")])
      : _c("div", [
          _c(
            "div",
            { staticClass: "fields", attrs: { "data-profile-fields": "" } },
            _vm._l(_vm.fields, function (field) {
              return _c(
                "div",
                {
                  key: field.id,
                  staticClass: "field",
                  attrs: {
                    "data-profile-field": "",
                    "data-size": field.size,
                    "data-type": field.type,
                    "data-new-line": field.newLine,
                  },
                },
                [
                  _c("profile-field", {
                    attrs: {
                      value: _vm.form[field.parentId],
                      field: field.config,
                      error: _vm.isSubmitted && _vm.errors[field.id],
                      editable: _vm.editable,
                    },
                    on: {
                      update: function ($event) {
                        return _vm.setFieldValue(field.parentId, $event)
                      },
                      change: function ($event) {
                        _vm.changesCounter += 1
                      },
                    },
                  }),
                ],
                1
              )
            }),
            0
          ),
          _c(
            "div",
            {
              staticClass: "actions",
              class: {
                fixed: _vm.fixFooter,
              },
            },
            [
              _c(
                "div",
                { staticClass: "actions__wrapper" },
                [
                  _c("c-button", {
                    staticClass: "actions__reset",
                    attrs: { label: "Отменить" },
                    on: { click: _vm.reset },
                  }),
                  _c("c-button", {
                    staticClass: "actions__submit",
                    attrs: {
                      label: "Сохранить",
                      color: "primary",
                      disabled: _vm.pending,
                      pending: _vm.pending,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.submit()
                      },
                    },
                  }),
                  _c("c-button", {
                    staticClass: "actions__submit actions__submit-and-close",
                    attrs: {
                      label: "Сохранить и закрыть",
                      color: "primary",
                      disabled: _vm.pending,
                      pending: _vm.pending,
                    },
                    on: { click: _vm.submitAndClose },
                  }),
                ],
                1
              ),
              _c("observer", {
                staticClass: "footer-observer",
                on: {
                  fullyVisible: function ($event) {
                    _vm.fixFooter = false
                  },
                  fullyHidden: function ($event) {
                    _vm.fixFooter = true
                  },
                },
              }),
            ],
            1
          ),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }